import React, { Component } from 'react';
import { enableAnimations } from 'config/helpers';
import { ContactFormFullwidth, AbsoluteCTA, Link } from 'components';
import {
  Banner,
  Process,
  Reasons,
  OurArticles,
  AwwwardsSlider,
} from './subcomponents';
import './WhyDesignMatters.scss';

class WhyDesignMatters extends Component {
  componentDidMount() {
    enableAnimations();
  }

  render() {
    const { allArticles } = this.props;

    return (
      <div className={'single-case-study wdm__container'}>
        <Banner />
        <Reasons />
        <div id={'designs'} className={'wdm__section wdm__showcase'}>
          <AwwwardsSlider />
        </div>
        <Process className={'wdm__section'} />
        <div className={'wdm__container--desktop'}>
          <ContactFormFullwidth
            id={'wdm-contact-form'}
            name={'why-design-matters-contact-form'}
            pardotLink={'https://go.boldare.com/l/688533/2019-02-28/x93'}
            designMail
          />
          <OurArticles allArticles={allArticles} />
        </div>
        <Link
          to={'/contact#form'}
          className={'wdm__container--mobile'}
          id={'wdm-contact-mobile'}
        >
          <AbsoluteCTA linkID={'why-design-matters'} />
        </Link>
      </div>
    );
  }
}

export default WhyDesignMatters;
